import { useEffect, useContext } from "react";
import i18n from "../i18n";
import { Login } from "../components";
import { I18N_CHANGE_LANGUAGE } from "../constants";
import styles from "../components/login/login.module.scss";
import logo from "../assets/bankname.png";
import background from "../assets/background.png";
import { AppContext } from "../context";

export const LoginPage = () => {
  useEffect(() => {
    window.addEventListener(I18N_CHANGE_LANGUAGE, (({
      detail,
    }: CustomEvent) => {
      i18n.changeLanguage(detail);
    }) as EventListener);
  }, []);

  const {
    appState: { user },
    setAppState,
  } = useContext(AppContext);

  user
    ? setAppState((prev) => ({
        ...prev,
        isLoading: false,
      }))
    : setAppState((prev) => ({
        ...prev,
        isLoading: true,
      }));

  return (
    user &&
    <div className={`${styles.loginPageContainer} fade-in`}>
      <div className={styles.loginSlider}>
        <div className={styles.loginSlideContainer}>
          <img src={logo} alt="bank-logo" className={styles.loginSlideLogo} />
          <img
            src={background}
            alt="IuviBANKING"
            className={styles.loginSlideImagen}
          />
        </div>
      </div>

      <Login />
    </div>
  );
};
